// extracted by mini-css-extract-plugin
module.exports = {"product-brief-guide-popup":"FeaturePopup_product-brief-guide-popup__rumvS"};